import type { FC } from 'react';
import { useIntl } from 'react-intl';

import type { CompanyKununuBadge } from '@xing-com/crate-common-graphql-types';
import { ModuleHeader } from '@xing-com/crate-entity-pages-common';
import {
  trackAwardAction,
  getTrackingUrl,
} from '@xing-com/crate-entity-pages-common/src/tracking';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import * as Styled from './awards.styles';

type AwardsProps = {
  badges: CompanyKununuBadge[];
  pageSlug: string;
};

export const Awards: FC<AwardsProps> = ({ badges, pageSlug }) => {
  const AWARDS_NUMBER = 4;
  const { pageContext } = usePageContext();

  const { formatMessage } = useIntl();

  const showMore =
    badges.length > AWARDS_NUMBER
      ? {
          to: getTrackingUrl({
            to: `${pageContext.basePath}/${pageSlug}/about_us?scroll=awards`,
            trackingKey: 'allAwards',
          }),
          copyKey: 'EP_SEE_ALL_AWARDS',
        }
      : null;

  const slicedBadges = badges.slice(0, AWARDS_NUMBER);

  return (
    <>
      <ModuleHeader
        headlineCopyKey="EP_AWARDS_HEADLINE"
        showMore={showMore}
        small={true}
      />

      <Styled.AwardWrapper>
        {slicedBadges.map(
          (badge, index) =>
            badge?.image?.[0].url && (
              <Styled.Card
                href={badge.awardUrl ?? undefined}
                onClick={() => trackAwardAction('entity_page_mainpage')}
                linkProps={{
                  'aria-label': formatMessage({
                    id: 'EP_AWARDS_CARD_ARIA_LABEL',
                  }),
                }}
                key={index}
                hideContent={index > 1}
                // @ts-expect-error FIXME
                target={'_blank'}
              >
                <Styled.Image
                  src={badge?.image?.[0].url}
                  loading="lazy"
                  alt={formatMessage({ id: 'EP_AWARDS_IMAGE_ALT_TEXT' })}
                />
              </Styled.Card>
            )
        )}
      </Styled.AwardWrapper>
    </>
  );
};
